// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "8af475d89611267cab3e619b8c5e5e95b76e53f2/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};